import {
  createNewVentilatorPromise,
  updateVentilatorPromise,
  deleteVentilatorPromise
} from "../utilities/ventilatorHelpers";

/**
 * @description - Defines a ventilator to work with in the app.
 */
export class Ventilator {
  /**
   * @param {string} id
   * @param {string} serialNumber
   * @param {string} manufacturer
   * @param {string} model
   * @param {string} type
   * @param {string} status
   * @param {string} condition
   * @param {object} location
   * @param {User} user
   * @param {object} team
   */
  constructor({
    id = null,
    serialNumber = "",
    manufacturer = "",
    model = "",
    type = "",
    status = "",
    condition = "",
    location = {},
    user = {},
    team = {}
  } = {}) {
    /**
     * @type {string}
     */
    this.id = id;
    /**
     * @type {string}
     */
    this.serialNumber = serialNumber;
    /**
     * @type {string}
     */
    this.manufacturer = manufacturer;
    /**
     * @type {string}
     */
    this.model = model;
    /**
     * @type {string}
     */
    this.type = type;
    /**
     * @type {string}
     */
    this.status = status;
    /**
     * @type {string}
     */
    this.condition = condition;
    /**
     * @type {Object}
     */
    this.location = location;
    /**
     * @type {User}
     */
    this.user = user;
    /**
     * @type {Object}
     */
    this.team = team;
  }

  /**
   * If there is an ID on the ventilator, update the DB record.
   * If there is no ID on the ventilator, create a new DB record.
   * @returns {Promise<string>} ventilator.id
   */
  save() {
    return new Promise((resolve, reject) => {
      this.id
        ? updateVentilatorPromise(this)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        : createNewVentilatorPromise(this)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            });
    });
  }

  get openLink() {
    return `/ventilator/${this.id}`;
  }

  open(router) {
    router.push(`/ventilator/${this.id}`).catch(error => {
      console.error(error);
    });
  }

  /**
   * - If the ventilator has an ID, delete it from the DB.
   * - Otherwise, error because it hasn't been saved yet.
   * @returns {Promise<string>}
   */
  delete() {
    return new Promise((resolve, reject) => {
      this.id
        ? deleteVentilatorPromise(this)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
        : reject("this ventilator has not been saved to the database yet");
    });
  }
}
